import getStaticElement from './get-static-element';

const getElementAttribute = (elementId, attr) => {
  const element = getStaticElement(elementId);

  return element && element.getAttribute(attr);
};

export default getElementAttribute;
